<template>
  <SupaPicture
    v-if="item.bucket && item.path"
    :bucket="item.bucket"
    :path="item.path"
  />
  <picture v-else>
    <img :src="src" :alt="alt" style="width: auto" />
    {{ src }}
  </picture>
</template>
<script lang="ts" setup>
const props = defineProps<{
  src: string;
  alt?: string;
}>();

const item = useBucketAndPath(() => props.src);
</script>
